import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
  Input,
} from "reactstrap"
import * as XLSX from "xlsx"
import ListPageHeader from "../../components/custom/ListPageHeader"
import ListPage from "../../components/custom/ListPage"
import { quizQuestionPageValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import {
  createQuizQuestionMutation,
  updateQuizQuestionMutation,
  deleteQuizQuestionMutation,
  getQuizQuestionsQuery,
  getOneQuizQuestionQuery,
  getAllAgeGroup,
  fileUploadQuery,
  CreateQuizQuestion,
} from "./Queries"
import { Helmet } from "react-helmet-async"
import { Checkbox } from "@mui/material"
import axios from "axios"
import { StatusCodes } from "constants/defaultValues"

class QuizQuestions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [25, 50, 100, 500],
      pageLimit: 25,
      totalCount: 0,
      keyField: "id",
      viewModal: false,
      quizQuestionList: [],
      question: [],
      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 25,
      },
      quizQuestion: {
        question: "",
      },
      columns: [
        {
          name: Message("s_no"),
          selector: row => row.number,
          sortable: true,
          width: "10%",
          cell: (row, index) => <span>{index + 1}</span>,
        },
        {
          name: Message("questionType"),
          selector: row => row.questionType,
          sortable: true,
          width: "20%",
          cell: row => <span>{row.questionType ? row.questionType : ""}</span>,
        },
        {
          name: Message("question"),
          selector: row => row.question,
          sortable: true,

          cell: row => <span>{row.question ? row.question : ""}</span>,
        },
        // {
        //   name: "Date Range",
        //   selector: "dateRange",
        //   sortable: true,
        //   cell: row => <span>{row.dateRange ? row.dateRange : ""}</span>,
        // },
        // {
        //   name: "Age Group Id",
        //   selector: "ageGroupId",
        //   sortable: true,
        //   cell: row => <span>{row.ageGroupId ? row.ageGroupId : ""}</span>,
        // },
        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          width: "20%",
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
      selectedOption: "",
      file: null,
      previewUrl: null,
      isValid: true,
      image_url: "",
    }
    this.handleImageChange = this.handleImageChange.bind(this)
  }
  handleImageChange(event) {
    let reader = new FileReader()
    let file = event.target.files[0]

    reader.onloadend = () => {
      this.setState({
        file: file,
        previewUrl: reader.result,
        // previewUrl: data.url,
        isValid: true,
      })
    }

    reader.readAsDataURL(file)
  }
  componentDidMount() {
    this.setState({ quizId: parseInt(this.props.match.params.id, 10) }, () => {
      this.getQuizQuestions()
    })

    // this.getAllAgeGroup()
  }

  // getAllAgeGroup = async () => {
  //   await QueryRequest(getAllAgeGroup).then(res => {
  //     this.setState({
  //       ageGroupList: res.data?.getAllAgeGroupMasters?.items.map(function (a) {
  //         return { value: a.id, label: a.ageGroupTitle }
  //       }),
  //     })
  //   })
  // }

  HandleRowClicked = row => {
    const { id } = row
    this.props.history.push(`/quiz-sub-questions/${id}`)
  }

  getQuizQuestions = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    values.quizId = this.state.quizId
    const response = await QueryRequest(getQuizQuestionsQuery, values)
    var quizQuestionsValue = response?.data?.getAllQuizQuestions?.items
    console.log(quizQuestionsValue)
    if (quizQuestionsValue) {
      this.setState({
        isLoading: false,
        quizQuestionList: quizQuestionsValue,
        totalPage:
          response?.data?.getAllQuizQuestions?.pagination?.totalCount /
          response?.data?.getAllQuizQuestions?.pagination?.pageLimit,
        totalCount: response?.data?.getAllQuizQuestions?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getQuizQuestions()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getQuizQuestions()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getQuizQuestions()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getQuizQuestions()
        }
      }
    )
  }

  handleEdit = row => {
    console.log("row", row)
    if (row) {
      const quizOptions = row.quizOptions || []
      this.setState({
        quizQuestionId: row.id,
        quizQuestion: {
          id: row.id,
          number: row.number,
          image_url: row.image_url,
          questionType: row.questionType,
          video_id: row.video_id,
          question: row.question,
          optionA: quizOptions[0]?.option || "",
          optionAId: quizOptions[0]?.id || null,
          isCorrectA: quizOptions[0]?.isCorrect ? true : false,
          optionB: quizOptions[1]?.option || "",
          optionBId: quizOptions[1]?.id || null,
          isCorrectB: quizOptions[1]?.isCorrect ? true : false,
          optionC: quizOptions[2]?.option || "",
          optionCId: quizOptions[2]?.id || null,
          isCorrectC: quizOptions[2]?.isCorrect ? true : false,
        },
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
        selectedOption: row.questionType,
      })
    }
  }

  unixconvert = values => {
    return new Date(values).toLocaleString()
  }
  /** Submit Function Start */
  handleSubmit = async values => {
    // //console.log(new Date(values.dateRangeMin).valueOf() / 1000)
    this.state.Label == "Add"
      ? this.addQuestion(values)
      : this.editQuestion(values)
    // const response = values.id
    //   ? await MutateRequest(updateQuizQuestionMutation, values)
    //   : await MutateRequest(createQuizQuestionMutation, values)
    // var quizQuestionValue = response?.data
    // if (quizQuestionValue && values.id) {
    //   SuccessMessage(Message("quizQuestion.update")),
    //     this.setState({
    //       manageEditModal: !this.state.manageEditModal,
    //     })
    //   this.getQuizQuestions()
    // } else {
    //   SuccessMessage(Message("quizQuestion.add")),
    //     this.setState({
    //       manageModal: !this.state.manageModal,
    //     })
    //   this.getQuizQuestions()
    // }
  }

  addQuestion = async values => {
    console.log("values1", values)
    if (this.state.photo) {
      await MutateRequest(CreateQuizQuestion, {
        data: this.state.question,
      })
        .then(res => SuccessMessage(Message("quizQuestion.add")))
        .catch(e => ErrorMessage(e))
      this.setState({
        manageModal: false,
      })
      this.getQuizQuestions()
    } else {
      let Data = {
        question: values.question,
        number: parseInt(values.number),
        quizId: this.state.quizId,
        questionType: values.questionType,
        video_id: values.video_id,
        image_url: values.image_url,
        // quizOptions: [
        //   {
        //     id: values.optionAId,
        //     option: values.optionA,
        //     isCorrect: values.isCorrectA ? true : false,
        //   },
        //   {
        //     id: values.optionBId,
        //     option: values.optionB,
        //     isCorrect: values.isCorrectB ? true : false,
        //   },
        //   {
        //     id: values.optionCId,
        //     option: values.optionC,
        //     isCorrect: values.isCorrectC ? true : false,
        //   },
        // ],
      }
      await MutateRequest(CreateQuizQuestion, { data: Data })
        .then(res => SuccessMessage(Message("quizQuestion.add")))
        .catch(e => ErrorMessage(e))
      this.setState({
        manageModal: !this.state.manageModal,
      })
      this.getQuizQuestions()
    }
  }

  editQuestion = async values => {
    let Data = {
      id: parseInt(values.id),
      data: {
        // dateRangeMin: (
        //   new Date(values.dateRangeMin).valueOf() / 1000
        // ).toString(),
        // dateRangeMax: (
        //   new Date(values.dateRangeMax).valueOf() / 1000
        // ).toString(),
        // ageGroupId: values.ageGroupId,
        quizId: this.state.quizId,
        number: parseInt(values.number),
        question: values.question,
        questionType: values.questionType,
        video_id: values.video_id,
        image_url: values.image_url,
        // quizOptions: [
        //   {
        //     id: values.optionAId,
        //     option: values.optionA,
        //     isCorrect: values.isCorrectA ? true : false,
        //   },
        //   {
        //     id: values.optionBId,
        //     option: values.optionB,
        //     isCorrect: values.isCorrectB ? true : false,
        //   },
        //   {
        //     id: values.optionCId,
        //     option: values.optionC,
        //     isCorrect: values.isCorrectC ? true : false,
        //   },
        // ],
      },
    }
    await MutateRequest(updateQuizQuestionMutation, Data)
      .then(res => SuccessMessage(Message("quizQuestion.update")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getQuizQuestions()
  }

  addBtnClick = () => {
    this.setState({
      quizQuestion: {},
      manageModal: !this.state.manageModal,
      Label: "Add",
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      quizQuestion: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      quizQuestion: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteQuizQuestion = async id => {
    this.setState({
      buttonAction: false,
    })
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteQuizQuestionMutation, values)
    const quizQuestiondeleteValue = response?.data
    console.log(response)
    if (quizQuestiondeleteValue.deleteQuizQuestion.status === "Success") {
      SuccessMessage(Message("quizQuestion.delete"))
      this.getQuizQuestions()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  handleOptionChange = event => {
    this.setState({ selectedOption: event.target.value })
    // this.setFieldValue("questionType", event.target.value)
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      quizQuestionDetail: url ? url : "",
    })
  }
  readExcel = file => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)

      fileReader.onload = e => {
        const bufferArray = e.target.result

        const wb = XLSX.read(bufferArray, { type: "buffer" })

        const wsname = wb.SheetNames[0]

        const ws = wb.Sheets[wsname]

        const data = XLSX.utils.sheet_to_json(ws)

        resolve(data)
      }

      fileReader.onerror = error => {
        ErrorMessage(error)
      }
    })

    promise.then(d => {
      d.map(i => {
        let Data = {
          question: i.Name,
          quizId: this.state.quizId,
          quizOptions: [
            {
              option: i.Name,
            },
            {
              option: i.Name,
            },
            {
              option: i.Name,
            },
          ],
        }
        this.state.question.push(Data)
      })
    })
  }

  render() {
    const initialValues = this.state.quizQuestion
    console.log(
      "this.state.quizQuestion",
      this.state.number,
      this.state.selectedOption,
      this.state.question,
      initialValues
    )
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.quizQuestions")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={`${"Home"}.${"Quiz Questions"}`}
                  // showBreadCrumb={false}
                  buttonText={Message("add.quizQuestion")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />
                {/* <Row style={{ float: "right" }}>
                  <Col xl="3" style={{ display: "flex" }} className="me-2">
                    <FormGroup>
                      <Input
                        style={{ display: "none" }}
                        id="Image"
                        type="file"
                        accept=".xlsx"
                        name="departmentLogoURL"
                        onChange={e => {
                          const file = e.target.files[0]
                          this.readExcel(file)
                          this.setState({
                            photo: e.target.files[0],
                          })
                        }}
                      />
                      <label for="Image" class="btn btn-primary">
                        <i class="far fa-file-excel"></i>
                      </label>
                      <br />
                      {this.state.photo ? (
                        <Label>{this.state.photo?.name}</Label>
                      ) : (
                        ""
                      )}
                    </FormGroup>
                  </Col> */}
                {/* <Col>
                    <Button
                      disabled={this.state.photo?.name == null}
                      className="primary"
                      onClick={() => this.addQuestion()}
                    >
                      Add
                    </Button>
                  </Col> */}
                {/* </Row> */}
                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.quizQuestionList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  rowClicked={this.HandleRowClicked}
                  pageSizeOptions={this.state.pageSizeOptions}
                  pageLimit={this.state.pageLimit}
                  onSort={this.handleSort}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
              <Row>
                <Col
                  xxs="12"
                  className="mb-4 ms-4 float-end position-relative"
                  // style={{
                  //   display: "flex",
                  //   flexDirection: "row",
                  //   alignItems: "flex-end",
                  //   marginLeft: "760px",
                  // }}
                >
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() => this.props.history.push("/quiz")}
                  >
                    {"Back"}
                  </Button>
                </Col>
              </Row>
            </Card>
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.quizQuestion")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span className=" text-lowercase">
                        {" "}
                        <strong>
                          {" "}
                          {this.state.quizQuestion?.question}
                        </strong>{" "}
                        {Message("quizQuestion")}{" "}
                      </span>
                      {"?"}
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    disabled={this.state.buttonAction}
                    onClick={() =>
                      this.deleteQuizQuestion(this.state.quizQuestion.id)
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="lg"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.quizQuestion")
                  : Message("update.quizQuestion")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                // validationSchema={quizQuestionPageValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="6" xl="6" sm="12" md="12" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              {/* <Checkbox  /> */}
                              <Label className="requiredField">
                                {Message("number")}
                              </Label>
                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="number"
                                onBlur={event => {
                                  event.target.value = event.target.value

                                  setFieldValue("number", event.target.value)
                                  this.setState({
                                    number: event.target.value,
                                  })
                                }}
                              />
                            </FormGroup>
                            {errors.optionC && (
                              <div className="invalid-feedback d-block">
                                {errors.number}
                              </div>
                            )}
                          </Col>
                          <Col lg="6" xl="6" sm="12" md="12" xs="6">
                            <FormGroup className="mt-2 form-group has-float-label">
                              {/* <Checkbox  /> */}
                              <Label className="requiredField">
                                {Message("questionType")}
                              </Label>
                              <Input
                                autoComplete="off"
                                className="form-control"
                                name="questionType"
                                type="select"
                                defaultValue={
                                  this.state.quizQuestion.questionType
                                }
                                // value={this.state.quizQuestion.questionType}
                                onChange={e => {
                                  // this.handleOptionChange,
                                  this.setState({
                                    selectedOption: e.target.value,
                                  })
                                  setFieldValue("questionType", e.target.value)
                                }}
                              >
                                <option value="">Select an option</option>
                                <option value="text">text</option>
                                <option value="image">Image</option>
                                <option value="video">Video</option>
                              </Input>
                            </FormGroup>
                            {errors.questionType && (
                              <div className="invalid-feedback d-block">
                                {errors.questionType}
                              </div>
                            )}
                          </Col>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("question")}
                              </Label>
                              <Field
                                component="textarea"
                                className="form-control"
                                name="question"
                                type="text"
                                onBlur={event => {
                                  event.target.value = event.target.value

                                  setFieldValue("question", event.target.value)
                                  this.setState({
                                    number: event.target.value,
                                  })
                                }}
                              />
                              {errors.question && (
                                <div className="invalid-feedback d-block">
                                  {errors.question}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          {/* <Col
                            lg="8"
                            xl="8"
                            sm="12"
                            md="12"
                            xs="6"
                            className="p-2"
                          >
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Field
                                className="ms-2"
                                type="checkbox"
                                name="isCorrectA"
                              />

                              <Label className="requiredField ms-3">
                                {Message("optionA")}
                              </Label>

                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="optionA"
                                type="text"
                              />
                            </FormGroup>
                            {errors.optionA && (
                              <div className="invalid-feedback d-block">
                                {errors.optionA}
                              </div>
                            )}
                          </Col>
                          <Col
                            lg="8"
                            xl="8"
                            sm="12"
                            md="12"
                            xs="6"
                            className="p-2"
                          >
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Field
                                className="ms-2"
                                type="checkbox"
                                name="isCorrectB"
                              />
                              <Label className="requiredField ms-3">
                                {Message("optionB")}
                              </Label>
                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="optionB"
                                type="text"
                              />
                            </FormGroup>
                            {errors.optionB && (
                              <div className="invalid-feedback d-block">
                                {errors.optionB}
                              </div>
                            )}
                          </Col>
                          <Col
                            lg="8"
                            xl="8"
                            sm="12"
                            md="12"
                            xs="6"
                            className="p-2"
                          >
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Field
                                className="ms-2"
                                type="checkbox"
                                name="isCorrectC"
                              />
                              <Label className="requiredField ms-3">
                                {Message("optionC")}
                              </Label>
                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="optionC"
                                type="text"
                              />
                            </FormGroup>
                            {errors.optionC && (
                              <div className="invalid-feedback d-block">
                                {errors.optionC}
                              </div>
                            )}
                          </Col> */}

                          {this.state.selectedOption === "image" && (
                            <Col lg="6" xl="6" sm="12" md="12" xs="6">
                              <FormGroup className="mt-2 form-group has-float-label">
                                <Label className="requiredField">
                                  {Message("Image")}
                                </Label>
                                <Input
                                  type="file"
                                  name="image_url"
                                  id="image_url"
                                  onChange={async e => {
                                    let file = e.target.files[0]
                                    let fileupload = {
                                      type: "photo",
                                      fileName:
                                        e.target.files?.[0]?.name.trim(),
                                    }
                                    console.log(e.target.files[0])
                                    const fileUploadresponse =
                                      await QueryRequest(
                                        fileUploadQuery,
                                        fileupload
                                      )
                                    let data =
                                      fileUploadresponse?.data?.getUploadUrl
                                    let url = data.url.split("?")[0]
                                    axios
                                      .put(data.url, file, {
                                        headers: {
                                          "Content-Type": file.type,
                                        },
                                      })
                                      .then(async res => {
                                        console.log(res)
                                        if (
                                          res.status.toString() ===
                                          StatusCodes.Success
                                        ) {
                                          console.log(res.config.url)
                                        } else {
                                          ErrorMessage(
                                            Message("fieldUpload.error")
                                          )
                                        }
                                      })
                                      .catch(err => alert("sdhfgsd"))
                                    setFieldValue("image_url", url)
                                    // this.handleImageChange(e)
                                  }}
                                />
                                {values.image_url && (
                                  <img
                                    src={values.image_url}
                                    alt="preview"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "200px",
                                    }}
                                  />
                                )}
                              </FormGroup>
                              {errors.image_url && (
                                <div className="invalid-feedback d-block">
                                  {errors.image_url}
                                </div>
                              )}
                            </Col>
                          )}
                          {this.state.selectedOption === "video" && (
                            <Col lg="6" xl="6" sm="12" md="12" xs="6">
                              <FormGroup className="mt-2 form-group has-float-label">
                                <Label className="requiredField">
                                  {Message("videoLink")}
                                </Label>
                                <Input
                                  autoComplete="off"
                                  className="form-control"
                                  name="video_id"
                                  type="text"
                                  defaultValue={
                                    this.state.quizQuestion.video_id
                                  }
                                  onChange={e => {
                                    setFieldValue("video_id", e.target.value)
                                  }}
                                ></Input>
                              </FormGroup>
                              {errors.video_id && (
                                <div className="invalid-feedback d-block">
                                  {errors.video_id}
                                </div>
                              )}
                            </Col>
                          )}
                        </Row>
                      </Fragment>
                    </ModalBody>
                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col sm={6} className="required">
                            &nbsp;{Message("mandatoryFields")}
                            <br></br>
                            {/* &nbsp;{Message("optionAIsCorrect")} */}
                          </Col>
                          <Col sm={6}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                <Button type="submit" color="primary">
                                  {this.state.Label === "Edit"
                                    ? Message("update")
                                    : Message("add")}
                                </Button>

                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(QuizQuestions)
